import { h } from "preact";
import logo from "../assets/images/logos/humanitix-purple.svg";
import { css } from "emotion";
import config from "../config";

const headerStyles = css({
  background: "#ffffff",
  zIndex: 1000,
  height: 70,
  width: "100%",
  position: "relative",
  boxShadow: "0 0 1px 0 #f1f1f1, 0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  "@media(max-width:1100px)": {
    height: 60
  }
});
const logoStyles = css({
  background: `url(${logo})`,
  width: "185px",
  height: "32px",
  display: "inline-block",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "left center",
  margin: "26px 0 0 60px",
  textIndent: "-9999px",
  "@media(max-width:1100px)": {
    width: "140px",
    height: "24px",
    margin: "24px 0 0 14px"
  }
});

const Header = ({}) => {
  const websiteURL = config("WEBSITE_URL");
  return (
    <header className={headerStyles}>
      <div
        style={{
          margin: "0 auto"
        }}
      >
        <a
          href={websiteURL}
          className={logoStyles}
          aria-label="Humanitix"
          label="Humanitix"
        >
          Humanitix
        </a>
      </div>
    </header>
  );
};
export default Header;



// WEBPACK FOOTER //
// ./components/Header.js